import getApiInstance from '@/services/Api.ts'

const api = getApiInstance()
export default {
  resetAdviceOnDemand(
    action?: 'salary_sacrifice' | 'concessional' | 'insurance' | 'debt' | 'default',
  ) {
    return api.Post('/v3/account/advice/reset-on-demand', { action })
  },
}
